import { render, staticRenderFns } from "./Yjd.vue?vue&type=template&id=5d2271ed"
import script from "./Yjd.vue?vue&type=script&lang=js"
export * from "./Yjd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports